
import { CharacterFeatureSource } from "@dndModels/character_feature_source/CharacterFeatureSource";
import { 
  CharacterFeatureBase,
  StandardFeatures,
} from "@dndModels";

export class CharacterStandardFeatures extends CharacterFeatureSource {
  source: StandardFeatures | null = null;

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      if (this.source_id === "" && obj.background_id) {
        this.source_id = obj.background_id;
      }
      if (this.char_feature_bases.length === 0 && obj.features && obj.features.length > 0) {
        obj.features.forEach((o: any) => {
          const fb = new CharacterFeatureBase(o);
          fb.source_id = this.source_id;
          fb.source_type = "Background";
          fb.source_name = this.name;
          // fb.root_id = this.source_id;
          // fb.root_type = "Background";
          // fb.root_name = this.name;
          fb.ancestries = [...this.ancestries.map(o => { return {...o}; })];
          this.char_feature_bases.push(fb);
        });
      }
    }
  }

  toDBObj(): any {
    const feature_source_obj = super.toDBObj();
    return {
      ...feature_source_obj
    };
  }

  clone(drop_ids = false): CharacterStandardFeatures {
    const clone = new CharacterStandardFeatures();
    clone.copy(this, drop_ids);
    return clone;
  }

  copy(copyMe: CharacterStandardFeatures, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.source = copyMe.source;
  }
}